import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PlanI18n_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
	planID: string;
	langCode: LangCode;
};

export const usePlanI18nArticleQuery = ({ hotelID, planID, langCode }: Props) => {
	const { data } = useCustomSuspenseQuery(PlanI18n_DesignPage_Query, {
		variables: { hotelID, planID, lang: langCode },
	});

	return {
		data,
	};
};
